import firebase from "firebase/app";

import "firebase/storage";
import "firebase/firestore";
import "firebase/auth";
import "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};


firebase.initializeApp(firebaseConfig);

// export default firebase_app;

export const auth = firebase.auth();
export const firebase_auth = firebase.auth;

export const storage = firebase.storage();
export const firestore = firebase.firestore();
export const analytics = firebase.analytics();



